import React from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap'
import AddClient from './FormComponents/AddClient'
import PageHeader from '../utils/PageHeader'

const AddClientContact = (props) => {
  const {assignToLead}=props;
  return (
    <React.Fragment>
      <PageHeader
        pageName='ADD CLIENT'
        breadcrump1='Home'
        breadcrump2='Add Client'
        link='/dashboard'
      />
      <Container className='p-3 ms-1' fluid>
        <Row>
          <Col>
            <Row>
              <Col>
                <Card>
                  <CardHeader className='card-header'>
                    <h4 className='card-title mb-0'>Add Client</h4>
                  </CardHeader>
                  <CardBody className='p-4'>
                    <AddClient assignToLead={assignToLead} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
}

export default AddClientContact
